import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
// Styles & Icons
import switchPayLogo from '@/assets/icons/logos/switch-pay.svg';
import { colors } from '@/theme';
// Utils
import { brand } from '@/brand/brand';
import { isEvmCryptoAsset } from '@nerdcoresdk/foundations-crypto';

const SwitchText = (currency) => (
  <Typography variant="body1">
    {`Send ${currency} to your ${brand.brandName} wallet from another compatible wallet, or use `}
    <a
      href="https://switchrewardcard.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: colors.switch.main,
        fontWeight: 'bold',
        textDecoration: 'underline',
      }}
    >
      Switch Pay
    </a>
    {` to purchase supported payment assets with your credit/debit card.`}
  </Typography>
);

export default function AddCoin({ close, setCard, cryptoAsset, featureFlags }) {
  const supportsSwitchPay =
    isEvmCryptoAsset(cryptoAsset) && cryptoAsset.traits.isDefaultLayer1;
  const showSwitch = featureFlags.ShowSwitchPay && supportsSwitchPay;

  return (
    <Paper
      sx={{
        margin: 'auto',
        marginTop: '120px',
        position: 'relative',
        maxWidth: '600px',
      }}
    >
      <Box sx={{ position: 'absolute', top: '4px', right: '4px' }}>
        <IconButton onClick={() => close()}>
          <Close />
        </IconButton>
      </Box>
      <Box sx={{ padding: '16px 0' }}>
        <Typography variant="h2">
          Add {cryptoAsset?.display.symbol} to your {brand.brandName} Wallet
        </Typography>
      </Box>
      {showSwitch ? (
        SwitchText(cryptoAsset?.display.symbol)
      ) : (
        <Typography variant="body1">
          {`Use a ${cryptoAsset?.display.symbol} compatible wallet to send funds to your ${brand.brandName} wallet.`}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '20px',
          width: '100%',
          gap: '20px',
        }}
        orientation="vertical"
      >
        <Button
          size="large"
          variant="outlined"
          onClick={() => setCard(1)}
          fullWidth={true}
          data-core-qa="addCurrencyButton"
        >
          Add {cryptoAsset?.display.symbol} with External Wallet
        </Button>
        {showSwitch && (
          <Button
            size="large"
            variant="contained"
            onClick={() => setCard(2)}
            fullWidth={true}
            data-core-qa="switchPayButton"
          >
            <img src={switchPayLogo.src} alt="Switch Pay" />
          </Button>
        )}
      </Box>
    </Paper>
  );
}
